import Backdrop from "components/global/Backdrop";
import Button from "components/global/Button";
import FormGroup from "components/global/FormGroup";
import FormWrapper from "components/global/FormWrapper";
import { Formik } from "formik";
import styled from "styled-components";
import Spacer from "components/global/Spacer";
import * as Yup from "yup";
import { helpCenter } from "api";
import { showAlert } from "utils/utils";

const Wrapper = styled(Backdrop)`
  .contentWrapper {
    position: relative;
    padding: 4.8rem;
    background-color: #ffffff;
    width: 430px;
    margin: 5% auto;
    border-radius: 1.6rem;

    form {
      width: 100%;
    }

    @media screen and (max-width: 1024px) {
      width: 80%;
    }

    @media screen and (min-width: 1440px) {
      margin: 7% auto;
    }
  }

  .actionBtns {
    gap: 24px;
    margin-top: 24px;

    .btn {
      width: calc(100% - 12px);
      margin-top: 0;
    }
  }

  @media screen and (max-width: 768px) {
    .contentWrapper {
      width: 100vw;
      height: 100vh;
      overflow: auto;
      margin: 0;
      border-radius: 0;
      padding: 2.4rem;
      padding-top: 7.2rem;
    }

    .title {
      font-size: 24px;
      line-height: 32px;
    }

    .description {
      font-size: 14px;
      line-height: 20px;
    }

    .actionBtns {
      gap: 12px;
  
      .btn {
        width: calc(100% - 6px);
      }
    }
  }
`;

const HelpCenter = () => {
  const submitForm = async (data, resetForm) => {
    try {
      const res = await helpCenter(data);

      if (res?.data?.status === true) {
        resetForm && resetForm();
        document.querySelector("#helpCenter").classList.remove("show");
        showAlert({
          msg: res.data.message,
          type: "success",
        });
      } else {
        showAlert({
          msg: "An error occurred. Message not sent.",
          type: "danger",
        });
      }
    } catch (e) {
      console.log(e);
      showAlert({
        msg: "Something went wrong",
        type: "danger",
      });
    }
  };

  const schema = Yup.object({
    name: Yup.string().required("Field required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Field required"),
    message: Yup.string().required("Field required"),
  });

  return (
    <Wrapper id="helpCenter">
      <div className="contentWrapper">
        <h4 className="colorGrey1 title textCenter">Contact sales</h4>
        <Spacer y={0.6} />
        <p className="colorBodyText l3 description textCenter">
          Please leave a message for us and our team will respond to you as soon
          as possible.
        </p>
        <Spacer y={2.4} />
        <Formik
          initialValues={{
            name: "",
            email: "",
            message: "",
          }}
          validationSchema={schema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            await submitForm(values, resetForm);
            setSubmitting(false);
          }}
        >
          {({ handleSubmit, isSubmitting, isValid, values }) => (
            <FormWrapper onSubmit={handleSubmit}>
              <FormGroup
                fieldStyle="shortText"
                label="Full name"
                name="name"
                className="spanFull"
                required={true}
              />
              <FormGroup
                fieldStyle="shortText"
                type="email"
                label="Work email"
                name="email"
                className="spanFull"
                required={true}
              />
              <FormGroup
                fieldStyle="longText"
                label="Leave a message"
                name="message"
                className="spanFull"
                required={true}
              />

              <div className="actionBtns flexRow alignCenter spanFull">
                <Button
                  type="button"
                  text="Cancel"
                  className="btn borderedGrey"
                  onClick={() =>
                    document
                      .querySelector("#helpCenter")
                      .classList.remove("show")
                  }
                />
                <Button
                  type="submit"
                  text={isSubmitting ? "..." : "Send message"}
                  className="btn"
                  disabled={
                    isSubmitting || !isValid || !values.email || !values.message
                  }
                />
              </div>
            </FormWrapper>
          )}
        </Formik>
      </div>
    </Wrapper>
  );
};

export default HelpCenter;
